import { useAppDispatch } from 'app/store';
import { setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { FC, useEffect } from 'react';
import ShopDotsUpdateUsersWidget from 'widgets/shopDots/ui/ShopDotsUpdateUsersWidget';

const ShopDotsUpdateUsers: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Обновить пользователей ТТ'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <ShopDotsUpdateUsersWidget />;
};

export default ShopDotsUpdateUsers;
